import { render, staticRenderFns } from "./sceneMenuPc.vue?vue&type=template&id=0d478b1f&scoped=true&"
import script from "./sceneMenuPc.vue?vue&type=script&lang=js&"
export * from "./sceneMenuPc.vue?vue&type=script&lang=js&"
import style0 from "./sceneMenuPc.vue?vue&type=style&index=0&id=0d478b1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d478b1f",
  null
  
)

export default component.exports